<template>
  <div>
    <el-table
      border
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column label="序号" type="index" width="50" align="center">
      </el-table-column>
      <el-table-column
        prop="auditWhether"
        label="审批结论"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.auditWhether == 1 ? '通过' : '不通过' }}
        </template>
      </el-table-column>
      <el-table-column
        prop="auditRemark"
        label="审批意见"
        show-overflow-tooltip
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="auditPerson"
        label="审批人"
        width="180"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="auditTime"
        label="审批时间"
        width="180"
        align="center"
      >
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  props: {
    tableData: Array
  },
  data() {
    return {}
  }
}
</script>
